export default __webpack_public_path__ + "static/media/IMG_3446 copie.d8af9884.jpg";